import React, { useState } from 'react';
import PetTypeSelectorCards, {
  PetTypeSelectorStyles,
  PetTypeData,
} from '@chewy/pet-profile-ux-components';

export const PetSelectorCardsSection = () => {
  const strings = {
    petTypeSelectorCardsTitle: 'Pet Type Selector Cards',
    isLoadedSubtitle: 'Is Loaded: ',
    loadErrorSubtitle: 'Load Error: ',
    selectedDataTitle: 'Selected Data: ',
    petTypeIDSubtitle: 'Pet Type ID: ',
    petTypeNameSubtitle: 'Pet Type Name: ',
    avatarImgURLSubtitle: 'Avatar Img URL: ',
  };

  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedPetTypeId, setSelectedPetTypeId] = useState(0);
  const [isLoadErrored, setIsLoadErrored] = useState(false);
  const [loadError, setLoadError] = useState('');
  const [showSelectedPetTypeId, setShowSelectedPetTypeId] = useState(false);
  const [selectedPetName, setSelectedPetName] = useState('None');
  const [selectedAvatarImgUrl, setSelectedAvatarImgUrl] = useState('None');

  const onLoaded = (_petTypeData: Array<PetTypeData>) => {
    setIsLoaded(true);
  };
  const onLoadError = (error: string) => {
    setIsLoadErrored(true);
    setLoadError(error);
  };
  const onSelection = (petTypeId: number, petTypeName: string, avatarImgUrl: string) => {
    setSelectedPetTypeId(petTypeId);
    setShowSelectedPetTypeId(true);
    setSelectedPetName(petTypeName);
    setSelectedAvatarImgUrl(avatarImgUrl);
  };

  return (
    <div className="component-card" key="pet-type-selector-cards">
      <h2>{strings.petTypeSelectorCardsTitle}</h2>

      <hr />
      <PetTypeSelectorCards
        pickerName="pet-type-selector-cards"
        style={PetTypeSelectorStyles.cards}
        onLoaded={onLoaded}
        onSelection={onSelection}
        onLoadError={onLoadError}
      />
      <div>
        <p>
          <strong>{strings.isLoadedSubtitle}</strong>
          {isLoaded ? 'true' : 'false'}
          <br />
          <strong>{strings.loadErrorSubtitle}</strong>
          {isLoadErrored ? loadError : 'None'}
        </p>
        <h5>{strings.selectedDataTitle}</h5>
        <p>
          <strong>{strings.petTypeIDSubtitle}</strong>
          {showSelectedPetTypeId ? selectedPetTypeId : 'None'}
          <br />
          <strong>{strings.petTypeNameSubtitle}</strong>
          {selectedPetName}
          <br />
          <strong>{strings.avatarImgURLSubtitle}</strong>
          {selectedAvatarImgUrl}
        </p>
      </div>
    </div>
  );
};
